'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function getReactElementPosition(element) {
  var node = element.current || element;
  var parentPos = node.offsetParent;
  return {
    top: node.offsetTop && parentPos.offsetTop && node.offsetTop - parentPos.offsetTop,
    left: node.offsetLeft && parentPos.offsetLeft && node.offsetLeft - parentPos.offsetLeft,
    height: node.offsetHeight,
    width: node.offsetWidth,
    boundingClientRect: node.getBoundingClientRect()
  };
}

var generateDimension = {
  getReactElementPosition: getReactElementPosition
};

exports.__moduleExports = generateDimension;
exports.default = generateDimension;
